import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {FITHGameConfig} from "../FITHGameConfig";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {FITHParsedInitData} from "../server/data/FITHParsedInitData";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {FITHParsedGameData} from "../server/data/FITHParsedGameData";
import {FITHGameMode} from "../gameMode/FITHGameMode";
import {FITHSoundManager} from "../sound/FITHSoundManager";

export class FITHWildMultiplierView extends BaseView {
    private _multiplierItem: BitmapCountUp;
    private _multiplierUpdateAnimation: TimelineSprite;
    private _multiplierValueRestore: number;
    private _nextMode: string = "";
    private _multiplierUpSoundPlayed: boolean = false;
    private _xBombIcon: PIXI.Sprite;

    private _isAborted: boolean = false;
    set isAborted(value: boolean) {
        this._isAborted = value;
    }

    public hideMultiplierItem(): void {
        if (this._nextMode === FITHGameMode.NORMAL || this._nextMode === FITHGameMode.BONUS) {
            this._multiplierItem.visible = false;
            this._multiplierItem.text = "";

            // #299, #315
            if (this._nextMode === FITHGameMode.BONUS) {
                this._xBombIcon.visible = false;
            } else {
                this._xBombIcon.alpha = 0.75;
            }
        }
    }

    // #299, #315
    public exitFS(): void {
        this._xBombIcon.visible = true;
        this._xBombIcon.alpha = 0.75;
    }

    /**
     * @description Update multiplier item text.
     * @param multiplier
     * @param isRestore
     */
    public updateMultiplierItem(multiplier: number, isRestore: boolean): void {
        const xOffset: number = 40;

        if (multiplier > 0 && (multiplier + "" !== this._multiplierItem.text.split("x")[1])) {
            this._multiplierItem.visible = true;
            this._multiplierItem.text = "x" + multiplier;
            while (this._multiplierItem.textWidth * this._multiplierItem.scaling > this._multiplierItem.maxTextWidth) {
                this._multiplierItem.fontSize--;
                this._multiplierItem.dirty = true;
                this._multiplierItem.updateTransform();
            }
            this._multiplierItem.pivot.set(this._multiplierItem.width / 2, 80 / 2);
            this._multiplierItem.x = ((FITHGameConfig.instance.REEL_AREA_POS_X + FITHGameConfig.instance.REEL_AREA_WIDTH) - xOffset - this._multiplierItem.width / 2);

            // #218
            if ((!this._isAborted || !this._multiplierUpSoundPlayed) && !isRestore) {
                this._multiplierUpSoundPlayed = true;
                FITHSoundManager.playMultiplierUp();
            }

            this._multiplierUpdateAnimation.getAnimationAutoShowHide(true, true);

            // #299, #315
            this._xBombIcon.alpha = 0.2;
        }
    }

    protected addEventListeners(): void {
        super.addEventListeners && super.addEventListeners();

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.onGameReady());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        StageManager.getLayer(FITHGameConfig.instance.LAYERS.WILD_MULTIPLIER_BOARD.name).addChild(this);
        this.createMultiplierItem();
        this.createMultiplierUpdateAnimation();
    }

    private onInitDataParsed(data: FITHParsedInitData): void {
        this._nextMode = data.nextMode;
        this._multiplierValueRestore = data.currentMultiplier;
    }

    private onGameReady(): void {
        if (this._multiplierItem && this._multiplierValueRestore > 1) {
            this.updateMultiplierItem(this._multiplierValueRestore, true);

            // #299
            if (this._nextMode === FITHGameMode.BONUS) {
                this._xBombIcon.visible = false;
            }
        }
    }

    private onGameDataParsed(data: FITHParsedGameData): void {
        this._nextMode = data.nextMode;

        this._multiplierUpSoundPlayed = false;
    }

    private createMultiplierItem(): void {
        const yPos: number = 125,
            xOffset: number = 40;

        this._multiplierItem = new BitmapCountUp({
            style: {
                font: {
                    name: "NumbersWinCountUp",
                    size: 20
                },
                tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
            },
            numberFormat: {
                precision: 0
            }
        });

        this._xBombIcon = new PIXI.Sprite(GameResources.getTextures("xBomb_icon")[0]);
        this._xBombIcon.anchor.set(0.5);
        this._xBombIcon.position.set(655, 113);

        this._multiplierItem.maxTextWidth = 150;
        this.hideMultiplierItem();
        this._multiplierItem.text = "";
        this._multiplierItem.position.set((FITHGameConfig.instance.REEL_AREA_POS_X + FITHGameConfig.instance.REEL_AREA_WIDTH) - xOffset - this._multiplierItem.width / 2, yPos);

        this.addChild(this._xBombIcon, this._multiplierItem);
    }

    private createMultiplierUpdateAnimation(): void {
        this._multiplierUpdateAnimation = new TimelineSprite(GameResources.getTextures("refresh"));
        this._multiplierUpdateAnimation.anchor.set(0.5);
        this._multiplierUpdateAnimation.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._multiplierUpdateAnimation.hide();
        this._multiplierUpdateAnimation.position.set(this._multiplierItem.x - 35, this._multiplierItem.y);

        this.addChild(this._multiplierUpdateAnimation);
    }
}